import { useEffect, useState } from 'react';
import { CarFrontFill } from 'react-bootstrap-icons';
import './ui.css';

/**
 * A car photo that can never break the layout: a missing URL and a URL that
 * fails to load both fall back to the same placeholder tile.
 */
const CarImage = ({src, alt = "", className = "", loading = "lazy", onClick}) => {
    const [failed, setFailed] = useState(false);

    // A new src deserves a fresh attempt, otherwise switching gallery photos
    // would keep showing the placeholder after one bad image.
    useEffect(() => {
        setFailed(false);
    }, [src]);

    const showPlaceholder = !src || failed;

    return (
        <div className={`cx-image ${className}`} onClick={onClick}>
            {showPlaceholder
                ? (
                    <div className="cx-image-placeholder" aria-hidden="true">
                        <CarFrontFill />
                    </div>
                )
                : (
                    <img
                        src={src}
                        alt={alt}
                        loading={loading}
                        onError={() => setFailed(true)}
                    />
                )}
        </div>
    );
};

export default CarImage;
